export default "__VITE_ASSET__DtrnhDtl__"